import React from 'react';

const DistrictSchemeTable = ({ 
  selectedState, 
  selectedScheme, 
  selectedFinancialYear,
  districtWiseData = [], // Receive data from parent
  loadingDistrictData = false // Receive loading state from parent
}) => {
  // Debug effect to track props and state
  React.useEffect(() => {
    console.log("🔍 DistrictSchemeTable State:", {
      selectedState: selectedState?.properties?.STATE,
      selectedScheme: selectedScheme?.schemeName,
      selectedFinancialYear,
      districtDataCount: districtWiseData.length,
      sampleData: districtWiseData.slice(0, 3),
      loading: loadingDistrictData
    });
  }, [selectedState, selectedScheme, selectedFinancialYear, districtWiseData, loadingDistrictData]);

  // Don't render if no state is selected
  if (!selectedState) {
    console.log("🚫 No state selected - hiding DistrictSchemeTable");
    return null;
  }

  const totalSurveys = districtWiseData.reduce(
    (sum, district) => sum + (district.totalSurvey || 0),
    0
  );

  return (
    <div className="mapRightBhuvanAnalytics mt-1">
      <div className="mapheader">
        <h2 className="mb-0">
          District-wise Data - {selectedState.properties.STATE}
          {selectedScheme && ` - ${selectedScheme.schemeName}`}
          {selectedFinancialYear && selectedFinancialYear !== "ALL" && ` (FY: ${selectedFinancialYear})`}
        </h2>
      </div>

      {loadingDistrictData && (
        <div className="text-center py-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2 mb-0">Loading district data...</p>
        </div>
      )}

      {!loadingDistrictData && (
        <div className="table-responsive District_allScheme">
          {districtWiseData.length > 0 ? (
            <>
              <table className="table table-bordered table-striped table-hover">
                <thead>
                  <tr>
                    <th width="60">S.No.</th>
                    <th>District Name</th>
                    <th width="150" className="text-end">Survey Count</th>
                  </tr>
                </thead>
                <tbody>
                  {districtWiseData
                    .sort((a, b) => (b.totalSurvey || 0) - (a.totalSurvey || 0))
                    .map((district, index) => (
                      <tr key={district.districtCode || district.districtName || index}>
                        <td className="text-muted text-center">{index + 1}</td>
                        <td>
                          {district.districtName || 'Unknown District'}
                        </td>
                        <td className="text-end fw-bold">
                          {district.totalSurvey.toLocaleString()}
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
                <tfoot>
                  <tr className="fw-bold table-active">
                    <td colSpan="2" className="text-end">Total Surveys:</td>
                    <td className="text-end">{totalSurveys.toLocaleString()}</td>
                  </tr>
                </tfoot>
              </table>
              <div className="text-muted small px-2">
                Showing {districtWiseData.length} districts • Total Surveys: {totalSurveys.toLocaleString()}
                {selectedFinancialYear === "ALL" && " • All Financial Years"}
              </div>
            </>
          ) : (
            <div className="text-center p-4">
              <i className="bi bi-inbox display-4 text-muted"></i>
              <p className="text-muted mt-2 mb-0">
                No district data available
                {selectedScheme && ` for ${selectedScheme.schemeName}`}
                {selectedFinancialYear && selectedFinancialYear !== "ALL" && ` in FY: ${selectedFinancialYear}`}
              </p>
              <small className="text-muted">
                State: {selectedState.properties.STATE}
              </small>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DistrictSchemeTable;